document.addEventListener('DOMContentLoaded', function () {
    const imagesGroups = document.querySelectorAll('.images-group');


    const toggleLinks = document.querySelectorAll('.images-toggle .nav-link[data-toggle]');

    toggleLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            // Find the parent .tab-content
            const tabContent = this.closest('.tab-content');

            // Remove active class from all links within the current .tab-content
            const currentToggleLinks = tabContent.querySelectorAll('.images-toggle .nav-link[data-toggle]');
            currentToggleLinks.forEach(link => link.classList.remove('active'));

            // Add active class to the clicked link
            this.classList.add('active');

            // Get the data-toggle value
            const toggleValue = this.getAttribute('data-toggle');

            // Hide all images within the current .tab-content
            const images = tabContent.querySelectorAll('.images-group');
            images.forEach(img => img.classList.add('hidden'));

            // Show the image that matches the data-toggle value within the current .tab-content
            const imageToShow = tabContent.querySelector(`.images .images-group[data-name="${toggleValue}"]`);
            if (imageToShow) {
                imageToShow.classList.remove('hidden');
            }

            // Hide all descriptions within the current .tab-content
            const descriptions = tabContent.querySelectorAll('.cat-description');
            descriptions.forEach(desc => desc.classList.add('hidden'));

            // Show the description that matches the data-toggle value within the current .tab-content
            const descriptionToShow = tabContent.querySelector(`.cat-description[data-tab="${toggleValue}"]`);
            if (descriptionToShow) {
                descriptionToShow.classList.remove('hidden');
            }
        });
    });
});
const searchProductsBtn = document.querySelector('.search-products-btn');
if (searchProductsBtn) {
    searchProductsBtn.addEventListener('click', function () {
        if ('undefined' !== typeof FWP) {
            FWP.refresh();
        }
    });
}

const viewAllProductsBtn = document.querySelector('.view-all-products-btn');
if (viewAllProductsBtn) {
    viewAllProductsBtn.addEventListener('click', function () {
        // Initialize the URL with the base path for your archive or product listing page
        // Get the domain and path from the current URL
        let url = window.location.origin + '/san-pham/';

        // Fetch facet data
        const facetData = FWP.buildQueryString(); // This uses FacetWP's API to get the current facets as a query string
        console.log(facetData);
        if (facetData) {
            url += '?' + facetData; // Append the facet data if any exists
        }

        // Redirect to the constructed URL
        window.location.href = url;
    });
}


document.addEventListener('facetwp-loaded', function () {
    const filterDropdowns = document.querySelectorAll('.filter-dropdown');

    filterDropdowns.forEach(dropdown => {
        const inputSearch = dropdown.querySelector('input[type="text"]');
        if (!inputSearch) return;

        const dropdownItems = dropdown.querySelectorAll('.facetwp-radio, .facetwp-checkbox');
        const checkedItems = dropdown.querySelectorAll('.facetwp-radio.checked, .facetwp-checkbox.checked');

        let text = '';

        const updateInputSearch = () => {
            inputSearch.value = text;
        };

        const setTextFromItem = (item) => {
            text = item.dataset.value === '' ? '' : item.querySelector('.facetwp-display-value').textContent;
            updateInputSearch();
        };

        // Set initial text from checked items
        checkedItems.forEach(setTextFromItem);

        // Normalize strings by removing special characters
        const normalizeString = (string) => string.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

        // Event delegation for item clicks
        dropdown.addEventListener('click', function (event) {
            const item = event.target.closest('.facetwp-radio, .facetwp-checkbox');
            if (item) setTextFromItem(item);
        });

        // Search filter by input text value on keyup event
        inputSearch.addEventListener('keyup', function () {
            const searchValue = normalizeString(this.value);
            dropdownItems.forEach(item => {
                const displayValueElement = item.querySelector('.facetwp-display-value');
                if (!displayValueElement) {
                    item.classList.add('hidden');
                    return;
                }
                const itemValue = normalizeString(displayValueElement.textContent);
                item.classList.toggle('hidden', searchValue !== '' && !itemValue.includes(searchValue));
            });

            // Reset to default if input is cleared
            if (searchValue === '') {
                dropdownItems.forEach(item => item.classList.remove('hidden'));
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const tabsSearch = document.querySelector('#tabs-search');
    if (!tabsSearch) {
        return;
    }
    const mainImage = tabsSearch.querySelector('.form-group #main-any');
    const images = tabsSearch.querySelectorAll('.form-group img:not(.main-image)');
    const closeButton = document.querySelector('.close');
    const spotButtons = document.querySelectorAll('.spot');
    const filterTop = tabsSearch.querySelector('.filter-top');
    const filterBottom = tabsSearch.querySelector('.filter-bottom');
    const filterButton = document.querySelector('.search-products-btn');
    const filterButtonTop = document.querySelector('.search-products-btn.btn-top');
    function toggleImage(targetId) {
        images.forEach(image => {
            image.classList.toggle('!hidden', image.id !== targetId);
        });
        mainImage.classList.add('!hidden');
        closeButton.classList.remove('!hidden');
    }

    function showMainImage() {
        images.forEach(image => image.classList.add('!hidden'));
        mainImage.classList.remove('!hidden');
        closeButton.classList.add('!hidden');
    }

    spotButtons.forEach(button => {
        button.addEventListener('click', function () {
            const targetId = button.getAttribute('data-target');
            const filters = tabsSearch.querySelectorAll('.filter-bottom .filter-item');
            filters.forEach(filter => {
                filter.classList.toggle('hidden', !filter.classList.contains('filter_' + targetId));
            });
            toggleImage(targetId);
            const radio = document.querySelector(`.facetwp-radio[data-value="${targetId}"]`);
            if (radio) {
                radio.click();
                if (typeof FWP !== 'undefined') {
                    FWP.refresh();
                    filterBottom.classList.add('show');
                    filterTop.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    });

    closeButton.addEventListener('click', () => {
        showMainImage();
        const radio = document.querySelector('.facetwp-radio.checked');
        if (radio) {
            radio.click();
            if (typeof FWP !== 'undefined') {
                FWP.reset();
                filterBottom.classList.remove('show');
            }
        }
        filterButtonTop.style.display = 'block';
    });
    if (filterButton) {
        filterButton.addEventListener('click', function () {
            if ('undefined' !== typeof FWP) {
                FWP.refresh();
                filterBottom.classList.add('show');
                filterButtonTop.style.display = 'none';
            }
        });
    }

});

function toggleImage() {
    const hoverTexts = document.querySelectorAll('.hover-text');
    const images = document.querySelectorAll('.images-group img');

    hoverTexts.forEach(hoverText => {
        hoverText.addEventListener('mouseover', function () {
            const target = this.getAttribute('data-image');
            images.forEach(image => {
                if (image.getAttribute('data-image') === target) {
                    image.classList.remove('hidden');
                } else {
                    image.classList.add('hidden');
                }
            });
        });

        hoverText.addEventListener('mouseout', function () {
            images.forEach(image => {
                if (image.classList.contains('default-image')) {
                    image.classList.remove('hidden');
                } else {
                    image.classList.add('hidden');
                }
            });
        });

        hoverText.addEventListener('click', function () {
            const target = this.getAttribute('data-image');
            images.forEach(image => {
                if (image.getAttribute('data-image') === target) {
                    image.classList.remove('hidden');
                } else {
                    image.classList.add('hidden');
                }
            });
        });
    });
}
toggleImage();

async function fetchLocations(id) {
    const domain = window.location.origin;
    // Add per_page=-1 to get all terms and include posts count
    const api = `${domain}/wp-json/wp/v2/vendor_location/?parent=${id}&per_page=100`;
    try {
        const response = await fetch(api);
        const data = await response.json();
        // Filter terms that have posts
        return data.filter(term => term.count > 0);
    }
    catch (error) {
        console.error('Error:', error);
        return [];
    }
}

async function fetchVendors(id) {
    const domain = window.location.origin;
    const api = `${domain}/wp-json/wp/v2/vendor?vendor_location=${id}&per_page=100`;
    try {
        const response = await fetch(api);
        const vendors = await response.json();
        return vendors;
    } catch (error) {
        console.error('Error:', error);
        return [];
    }
}

function renderVendor(vendor, isFirst = false) {
    const address = vendor.acf.vendor_address || '';
    const phone = vendor.acf.vendor_phone || '';
    const phone2 = vendor.acf.vendor_phone_2 || '';
    const googleMap = vendor.acf.google_map || '';
    
    // Extract map src from embed code
    const mapSrc = googleMap.match(/src="([^"]+)"/)?.[1] || '';
    
    // Format phone numbers
    const formatPhone = (phone) => {
        const cleaned = phone.replace(/[^0-9]/g, '');
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
    };

    return `
        <div class="vendor map-item group bg-stone-100 p-4 lg:p-8 rounded-lg lg:rounded-2xl hover:text-white ${isFirst ? 'active' : ''} [&.active]:bg-black [&.active]:text-white hover:bg-black transition-colors duration-300">
            <h3 class="uppercase font-bold text-lg lg:text-2xl group-hover:text-white group-[.active]:text-white mb-3">
                ${vendor.title.rendered}
            </h3>
            <p class="address lg:text-lg flex gap-2 mb-2">
                <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z" clip-rule="evenodd"/>
                </svg>
                <span>${address}</span>
            </p>
            <p class="phone lg:text-lg flex gap-2">
                <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M18.427 14.768 17.2 13.542a1.733 1.733 0 0 0-2.45 0l-.613.613a1.732 1.732 0 0 1-2.45 0l-1.838-1.84a1.735 1.735 0 0 1 0-2.452l.612-.613a1.735 1.735 0 0 0 0-2.452L9.237 5.572a1.6 1.6 0 0 0-2.45 0c-3.223 3.2-1.702 6.896 1.519 10.117 3.22 3.221 6.914 4.745 10.12 1.535a1.601 1.601 0 0 0 0-2.456Z"/>
                </svg>
                <span>
                    <a href="tel:${phone}">${formatPhone(phone)}</a>
                </span>
                ${phone2 ? `
                    <span class="ml-4">
                        <a href="tel:${phone2}">${formatPhone(phone2)}</a>
                    </span>
                ` : ''}
            </p>
            <button class="view-map text-lg flex w-full items-center justify-between pb-1 border-b border-black mt-4 group-hover:border-white relative after:content-[''] after:block after:w-1/2 after:h-[2px] after:bg-white after:origin-left after:absolute after:bottom-[-1px] after:left-0 after:scale-x-0 hover:after:scale-100 after:transition-transform after:duration-300 group-[.active]:border-white" data-map="${mapSrc}">
                <span>Xem bản đồ</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="!w-6 h-auto">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 12l14 0"></path>
                    <path d="M13 18l6 -6"></path>
                    <path d="M13 6l6 6"></path>
                </svg>
            </button>
        </div>
    `;
}

async function updateVendorsList(locationId) {
    const vendorWrapper = document.querySelector('#vendor-wrapper');
    if (!vendorWrapper) return;

    // Show loading state
    vendorWrapper.innerHTML = '<div class="text-center">Loading...</div>';

    try {
        const vendors = await fetchVendors(locationId);
        
        if (vendors.length === 0) {
            vendorWrapper.innerHTML = '<div class="text-center">No vendors found in this location</div>';
            return;
        }

        const vendorsHTML = vendors.map((vendor, index) => 
            renderVendor(vendor, index === 0)
        ).join('');

        vendorWrapper.innerHTML = vendorsHTML;

        // Update map for first vendor
        const firstMapSrc = vendors[0]?.acf?.google_map?.match(/src="([^"]+)"/)?.[1];
        if (firstMapSrc) {
            const mapWrapper = document.querySelector('#map-wrapper');
            viewMap();
        }
    } catch (error) {
        console.error('Error loading vendors:', error);
        vendorWrapper.innerHTML = '<div class="text-center">Error loading vendors</div>';
    }
}

function initLocationFilters() {
    const selects = document.querySelectorAll('.filter-select');
    if (!selects.length) return; // Exit if no selects found

    const khuVucSelect = selects[0];
    const tinhThanhSelect = selects[1];
    const quanHuyenSelect = selects[2];

    // Exit if required selects don't exist
    if (!khuVucSelect || !tinhThanhSelect || !quanHuyenSelect) return;

    function resetChildSelects(startIndex) {
        for (let i = startIndex; i < selects.length; i++) {
            if (selects[i] && selects[i].options[0]) {
                selects[i].innerHTML = `<option value="">${selects[i].options[0].text}</option>`;
                selects[i].disabled = true;
            }
        }
    }

    function populateSelect(select, data) {
        if (!select) return;
        let options = `<option value="">${select.options[0].text}</option>`;
        data.forEach(item => {
            if (item.count > 0) {
                options += `<option value="${item.id}">${item.name} (${item.count})</option>`;
            }
        });
        select.innerHTML = options;
        select.disabled = false;
    }

    khuVucSelect.addEventListener('change', async function () {
        resetChildSelects(1);
        if (!this.value) return;

        try {
            const locations = await fetchLocations(this.value);
            if (locations.length > 0) {
                populateSelect(tinhThanhSelect, locations);
            }
            await updateVendorsList(this.value);
        } catch (error) {
            console.error('Error fetching tinh/thanh:', error);
        }
    });

    tinhThanhSelect.addEventListener('change', async function () {
        resetChildSelects(2);
        if (!this.value) return;

        try {
            const locations = await fetchLocations(this.value);
            if (locations.length > 0) {
                populateSelect(quanHuyenSelect, locations);
                await updateVendorsList(this.value);
            }
        } catch (error) {
            console.error('Error fetching quan/huyen:', error);
        }
    });

    quanHuyenSelect.addEventListener('change', async function () {
        if (!this.value) return;
        await updateVendorsList(this.value);
    });
}


// Initialize filters when DOM is loaded
document.addEventListener('DOMContentLoaded', initLocationFilters);

const viewMap = () => {
    const viewMapItems = document.querySelectorAll('.map-item');
    const viewMapButtons = document.querySelectorAll('.view-map');
    const mapWrapperIframe = document.querySelector('#map-wrapper iframe');

    // Get the initial map source from the first .view-map button
    if (viewMapButtons.length > 0) {
        const initialMapSrc = viewMapButtons[0].getAttribute('data-map');
        // Initialize the map when the page loads
        if (initialMapSrc) {
            mapWrapperIframe.setAttribute('src', initialMapSrc);
        }
    }

    if (viewMapButtons) {
        viewMapButtons.forEach(button => {
            button.addEventListener('click', () => {
                const mapEmbedSrc = button.getAttribute('data-map');
                console.log(mapEmbedSrc);
                viewMapItems.forEach(item => item.classList.remove('active'));
                button.parentElement.classList.add('active');
                mapWrapperIframe.setAttribute('src', mapEmbedSrc);
                mapWrapperIframe.scrollIntoView({ behavior: 'smooth' });
            });
        });
    }
};

document.addEventListener('DOMContentLoaded', viewMap);